import React from 'react';
import { deepFind, deepFilter } from 'react-children-utilities';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function isReactElement(node) {
  return React.isValidElement(node);
}

const Close = ({ children }) => <>{children}</>;
const FooterLeft = ({ children }) => <>{children}</>;
const FooterRight = ({ children }) => <>{children}</>;
const Title = ({ children }) => <>{children}</>;
const Col = ({ children }) => <>{children}</>;

const Header = ({ children }) => <>{children}</>;
Header.Title = Title;
Header.Close = Close;

const Body = ({ children }) => <>{children}</>;
Body.Col = Col;

const Footer = ({ children }) => <>{children}</>;
Footer.Left = FooterLeft;
Footer.Right = FooterRight;

const CardConfigure = ({ children, type, addHeaderClass, ...rest }) => {
  const header = deepFind(children, (child) =>  child.type === Header) ;
  const body = deepFind(children, (child) =>  child.type === Body) ;
  const footer = deepFind(children, (child) => child.type === Footer) ;
  const footerLeft = deepFind(children, (child) =>  child.type === FooterLeft) ;
  const footerRight = deepFind(children, (child) =>child.type === FooterRight) ;
  const title = deepFind(children, (child) =>  child.type === Title) ;

  const cols = deepFilter(isReactElement(body) ? body.props.children : [], (child) => child);
  const containerClass = classNames('DS__card-configure', addHeaderClass);

  function getPropsChildren(element){
    return element?.props?.children ?? null;
  }

  return (
    <div className={containerClass} {...rest} >
      {header && <div className='DS__card-configure__header'>{getPropsChildren(title)}</div>}

      {body && (
        <div className="DS__card-configure__content">
          {cols
            ? cols.map((col, index) =>
                isReactElement(col) ? <div key={index}>{col?.props?.children}</div> : null
              )
            : null}
        </div>
      )}

      {footer && (
        <div className="DS__card-configure__footer">
          {footerLeft && (
            <div className="DS__card-configure__footer__left">{getPropsChildren(footerLeft)}</div>
          )}
          {footerRight && (
            <div className="DS__card-configure__footer__right">{getPropsChildren(footerRight)}</div>
          )}
        </div>
      )}
    </div>
  );
};

// Assign SubComponents to the CardConfigure component
CardConfigure.Header = Header;
CardConfigure.Header.Title = Title;
CardConfigure.Header.Close = Close;
CardConfigure.Body = Body;
CardConfigure.Body.Col = Col;
CardConfigure.Footer = Footer;
CardConfigure.Footer.Left = FooterLeft;
CardConfigure.Footer.Right = FooterRight;



// PropTypes for Close, FooterLeft, FooterRight, Title, Col
Close.propTypes = {
	children: PropTypes.node,
  };

  FooterLeft.propTypes = {
	children: PropTypes.node,
  };

  FooterRight.propTypes = {
	children: PropTypes.node,
  };

  Title.propTypes = {
	children: PropTypes.node,
  };

  Col.propTypes = {
	children: PropTypes.node,
  };
  Header.propTypes = {
	children: PropTypes.node,
  };
  Header.Title.propTypes = {
	children: PropTypes.node,
  };
  Header.Close.propTypes = {
	children: PropTypes.node,
  };
  Body.propTypes = {
	children: PropTypes.node,
  };
  Body.Col.propTypes = {
	children: PropTypes.node,
  };
  Footer.propTypes = {
	children: PropTypes.node,
  };
  Footer.Left.propTypes = {
	children: PropTypes.node,
  };
  Footer.Right.propTypes = {
	children: PropTypes.node,
  };

  // PropTypes for CardConfigure
  CardConfigure.propTypes = {
	children: PropTypes.node,
	type: PropTypes.string,
	addHeaderClass: PropTypes.string,
  };

export default CardConfigure;
